import { Outlet } from "react-router";

import { AuthWrapper } from "./components/AuthWrapper";

export default function Route() {
  return (
    <AuthWrapper>
      <Outlet />
    </AuthWrapper>
  );
}
